var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoneySolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M11.3333 13.6673H4.66659C2.66659 13.6673 1.33325 12.6673 1.33325 10.334V5.66732C1.33325 3.33398 2.66659 2.33398 4.66659 2.33398H11.3333C13.3333 2.33398 14.6666 3.33398 14.6666 5.66732V10.334C14.6666 12.6673 13.3333 13.6673 11.3333 13.6673Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10C9.10457 10 10 9.10457 10 8C10 6.89543 9.10457 6 8 6C6.89543 6 6 6.89543 6 8C6 9.10457 6.89543 10 8 10Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 5.16602H10.6667C10.3934 5.16602 10.1667 4.93935 10.1667 4.66602C10.1667 4.39268 10.3934 4.16602 10.6667 4.16602H12.6667C12.9401 4.16602 13.1667 4.39268 13.1667 4.66602C13.1667 4.93935 12.9401 5.16602 12.6667 5.16602Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33325 11.834H3.33325C3.05992 11.834 2.83325 11.6073 2.83325 11.334C2.83325 11.0607 3.05992 10.834 3.33325 10.834H5.33325C5.60659 10.834 5.83325 11.0607 5.83325 11.334C5.83325 11.6073 5.60659 11.834 5.33325 11.834Z",
    fill: "#020607"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneySolid);
export default __webpack_public_path__ + "static/media/money-solid.619870fa5383f332f05fb99bfc72e58a.svg";
export { ForwardRef as ReactComponent };